export default __webpack_public_path__ + "static/media/kibana-svgrepo-com.7782762e.svg";